import { VideoType } from './constants';
import { OrientationType } from './constants';

export type AdStatus = 'Under Review' | 'Approved' | 'Rejected';

export class Advertisement {
  id: string;
  fileName: string;
  fileRef: string;
  fileSize: number;
  fileType: string;
  fileUrl: string;
  fileDuration: number;
  orientation: OrientationType;
  quality: VideoType;
  status: AdStatus;
  uid: string;

  constructor(
    id?: string,
    fileName?: string,
    fileRef?: string,
    fileSize?: number,
    fileType?: string,
    fileUrl?: string,
    fileDuration?: number,
    orientation?: OrientationType,
    quality?: VideoType,
    status?: AdStatus,
    uid?: string
  ) {
    this.id = id || null;
    this.fileName = fileName || null;
    this.fileRef = fileRef || null;
    this.fileSize = fileSize || null;
    this.fileType = fileType || null;
    this.fileUrl = fileUrl || null;
    this.fileDuration = fileDuration || 10;
    this.orientation = orientation || 'landscape';
    this.quality = quality || 'hd';
    this.status = status || 'Under Review';
    this.uid = uid || null;
  }
}
